import CloudinaryImage from "@/components/cloudinary-image";

export interface PhotoType {
  imageId?: string;
}

interface PhotosListProps {
  openGallery: (index: number) => void;
  photos: PhotoType[];
}

export default function PhotosList({ openGallery, photos }: PhotosListProps) {
  return (
    <div className="scrollbar-hidden -mr-6 flex snap-x snap-mandatory gap-2.5 overflow-auto pr-6 md:mr-0 md:gap-3.5 md:pr-0">
      {photos.map(
        ({ imageId }, index) =>
          !!imageId && (
            <CloudinaryImage
              alt={imageId}
              className="aspect-square max-w-1/4 shrink-0 grow-1 basis-[calc(25%-14px)] cursor-pointer snap-start rounded-[5px] md:nth-[1n+5_of_type]:hidden"
              imageId={imageId}
              itemProp="image"
              onClick={() => openGallery(index)}
              rW={300}
            />
          )
      )}
    </div>
  );
}
